import {_ReactPixi, applyDefaultProps, PixiComponent} from '@inlet/react-pixi';
import {CoreDI} from '@gongxigames/framework/core/configs';
import {ResourceLoader} from '@gongxigames/framework/core/services/resourceLoader/ResourceLoader';
import {Sprite, Texture} from 'pixi.js';
import {inversifyContainer} from '@gongxigames/framework/core/installer';

export type CoreSpriteProps = Omit<_ReactPixi.ISprite, 'texture'> & {
    src?: string;
};

let LOADER: ResourceLoader|undefined;

export const CoreSprite = PixiComponent<CoreSpriteProps, Sprite>('CoreSprite', {
    create(props: CoreSpriteProps): Sprite {
        return new Sprite();
    },

    applyProps(instance: Sprite, oldProps: CoreSpriteProps, newProps: CoreSpriteProps): void {
        if (newProps.src) {
            instance.name = newProps.src;
        }

        LOADER ||= inversifyContainer.get<ResourceLoader>(CoreDI.ResourceLoader);

        instance.texture = LOADER.getTexture(newProps.src!) || Texture.EMPTY;

        applyDefaultProps(instance, oldProps, newProps);
    }
});
